import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { Outlet } from 'react-router-dom';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import DriveSweepGrid from './drive-sweep-grid';

export default function DriveSweep() {
  const isFormPage = useRouteMatch([
    `${pagesConfig.driveSweep.link}/${pagesConfig.createDriveSweepFormPage.link}`,
  ]);
  if (isFormPage) return <Outlet />;
  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        { label: pagesConfig.driveSweep.name },
      ]}
      bookmarkKey={pagesConfig.driveSweep.value}
    >
      <DriveSweepGrid />
    </SimpleBreadcrumbsPage>
  );
}
